import { Pipe, PipeTransform } from '@angular/core';
import { DataViewStyle, ViewStyleConfig } from '@osos/shared/types';

@Pipe({
  standalone: true,
  name: 'getViewConfigCssRulesPipe',
})
export class GetViewConfigCssRulesPipe implements PipeTransform {
  transform(
    viewStyleConfigProp: keyof ViewStyleConfig,
    uiAttributes: DataViewStyle,
  ): string {
    if (!viewStyleConfigProp || !uiAttributes) {
      return '';
    }
    const cssRule = uiAttributes?.cssStyle?.[viewStyleConfigProp];
    return cssRule || '';
  }
}
